import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import HomeIcon from "@mui/icons-material/Home";
// import PersonAddAlt1TwoToneIcon from "@mui/icons-material/PersonAddAlt1TwoTone";
// import ContactMailIcon from "@mui/icons-material/ContactMail";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import DonutSmallOutlinedIcon from "@mui/icons-material/DonutSmallOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import CategoryIcon from "@mui/icons-material/Category";
// import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import ArchiveIcon from "@mui/icons-material/Archive";
// import UsersPage from "../pages/Users/Users.page";
import HomePage from "../pages/Home/Home.page";
import Settings from "@mui/icons-material/SettingsOutlined";
// import AddBusiness from "@mui/icons-material/AddBusinessOutlined";
// import EcomercePage from "../pages/configuracoes/Ecomerce.page";
import OrdersPage from "../pages/Orders/Orders.page";
// import FornecedoresPage from "../pages/configuracoes/Fornecedores.page";
import PurchaseOrder from "../pages/Storage/PurchaseOrder.page";
import StoragePage from "../pages/Storage/Storage.page";
// import { CommissionPage } from "../pages/Registers/Commission.page";
import SkuPage from "../pages/Registers/Sku.page";
import IntegrationsPage from "../pages/configuracoes/Integracoes.page";
// import RulesPage from "../pages/configuracoes/Rules.page";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ViewListIcon from "@mui/icons-material/ViewList";
import CampaignIcon from "@mui/icons-material/Campaign";
import CatalogoPage from "../pages/Produtos/Catalogo.page";
import MetricasPage from "../pages/Produtos/Metricas.page";
import CampanhasPage from "../pages/Produtos/Campanhas.page";
import FreteGratisPage from "../pages/Produtos/FreteGratis.page";
import ReferenciasPrecoPage from "../pages/Produtos/ReferenciasPreco.page";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ImpostosPage from "../pages/configuracoes/Impostos.page";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import QrCodeIcon from "@mui/icons-material/QrCode";
import HandymanIcon from "@mui/icons-material/Handyman";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import PrintNfeLabel from "../pages/Labels/PrintNfeLabel.page";
import PrintOrderLabel from "../pages/Labels/PrintOrderLabel.page";
import AuxilioExpedicao from "../pages/Labels/AuxilioExpedicao.page";
import StarIcon from "@mui/icons-material/Star";
import PlanoAtualPage from "../pages/configuracoes/PlanoAtual.page";

const Menus = [
  {
    segment: "/dashboard",
    title: "Dashboard",
    icon: <HomeIcon />,
    component: <HomePage />,
  },
  {
    segment: "",
    title: "Pedidos",
    icon: <ShoppingCartIcon />,
    children: [
      {
        segment: "",
        title: "Analise margem",
        icon: <DonutSmallOutlinedIcon />,
        component: <OrdersPage />,
      },
      // {
      //   segment: "",
      //   title: "Monitoramento margem",
      //   icon: <PreviewIcon />,
      //   component: <MonitoringPage />,
      // },
    ],
  },
  {
    segment: "",
    title: "Estoque",
    icon: <WarehouseIcon />,
    children: [
      {
        segment: "",
        title: "Ordem de compra",
        icon: <AddShoppingCartIcon />,
        component: <PurchaseOrder />,
      },
      {
        segment: "",
        title: "Analise Estoque",
        icon: <Inventory2OutlinedIcon />,
        component: <StoragePage />,
      },
    ],
  },
  {
    segment: "",
    title: "Cadastros",
    icon: <ArchiveIcon />,
    children: [
      {
        segment: "",
        title: "Skus",
        icon: <CategoryIcon />,
        component: <SkuPage />,
      },
      // {
      //   segment: "",
      //   title: "Comissão",
      //   icon: <AttachMoneyIcon />,
      //   component: <CommissionPage />,
      // },
    ],
  },
  {
    segment: "",
    title: "Produtos",
    icon: <Inventory2OutlinedIcon />,
    children: [
      {
        segment: "",
        title: "Catálogo",
        icon: <ViewListIcon />,
        component: <CatalogoPage />,
      },
      {
        segment: "",
        title: "Métricas",
        icon: <AssessmentIcon />,
        component: <MetricasPage />,
      },
      {
        segment: "",
        title: "Campanhas",
        icon: <CampaignIcon />,
        component: <CampanhasPage />,
      },
      {
        segment: "",
        title: "Frete Grátis",
        icon: <AttachMoneyIcon />,
        component: <FreteGratisPage />,
      },
      {
        segment: "",
        title: "Referências",
        icon: <TrendingUpIcon />,
        component: <ReferenciasPrecoPage />,
      },
    ],
  },
  {
    segment: "",
    title: "Etiquetas",
    icon: <LocalShippingIcon />,
    children: [
      {
        segment: "",
        title: "Por NF-e",
        icon: <QrCodeIcon />,
        component: <PrintNfeLabel />,
      },
      {
        segment: "",
        title: "Por Pedido",
        icon: <ReceiptLongIcon />,
        component: <PrintOrderLabel />,
      },
      {
        segment: "",
        title: "Auxíliar Exp",
        icon: <HandymanIcon />,
        component: <AuxilioExpedicao />,
      },
    ],
  },
  // {
  //   segment: "",
  //   title: "Clientes",
  //   icon: <PersonAddAlt1TwoToneIcon />,
  //   component: <UsersPage />,
  // },
  {
    segment: "",
    title: "Configurações",
    icon: <Settings />,
    children: [
      // {
      //   segment: "",
      //   title: "Ecomerce",
      //   icon: <AddBusiness />,
      //   component: <EcomercePage />,
      // },
      // {
      //   segment: "",
      //   title: "Regras",
      //   icon: <GavelIcon />,
      //   component: <RulesPage />,
      // },
      // {
      //   segment: "",
      //   title: "Fornecedores",
      //   icon: <ContactMailIcon />,
      //   component: <FornecedoresPage />,
      // },
      {
        segment: "",
        title: "Plano Atual",
        icon: <StarIcon />,
        component: <PlanoAtualPage />,
      },
      {
        segment: "",
        title: "Integrações",
        icon: <IntegrationInstructionsIcon />,
        component: <IntegrationsPage />,
      },
      {
        segment: "",
        title: "Impostos",
        icon: <AccountBalanceIcon />,
        component: <ImpostosPage />,
      },
    ],
  },
];

export { Menus };
